<section class="d-flex flex-column flex-grow-1 position-relative h-100" style="overflow-x: auto">
  <router-outlet></router-outlet>
  @if(isLoading) {
  <app-loading></app-loading>
  }
</section>
